<script>
import Loading from "@/components/Loading.vue";

export default {
  name: "centres",
  components: {
    Loading,
  },
  data() {
    return {
      dataUrl: "/mip_api/eightMajor/searchCentre",
      langQ: "En",
      pageData: null,
      listData: [],
      language: "en_US",
      isLoading: false,
    };
  },

  computed: {
    effectiveLanguage() {
      const lang = this.$route.query.lang || this.$store.state.language || "en_US";
      return ["en_US", "zh_HK", "zh_CN"].includes(lang) ? lang : "en_US";
    },
  },
  async mounted() {
    await this.reloadPageData();
  },
  watch: {
    effectiveLanguage: {
      immediate: true,
      async handler() {
        this.setLanguageContext();
        if (Array.isArray(this.listData) && this.listData.length) return;
        await this.reloadPageData();
      },
    },
  },
  methods: {
    closeSelectList() {
      // Kept for template compatibility; no dropdown on this page currently.
    },
    setLanguageContext() {
      const languagePrefixMap = {
        en_US: "En",
        zh_HK: "Tc",
        zh_CN: "Sc",
      };
      this.language = this.effectiveLanguage;
      this.langQ = languagePrefixMap[this.language] || "En";
    },
    getLocalizedValue(row, baseKey) {
      if (!row || !baseKey) return "";
      const suffixMap = {
        en_US: ["En", "EN", "en"],
        zh_HK: ["Tc", "TC", "tc"],
        zh_CN: ["Sc", "SC", "sc"],
      };
      const suffixes = suffixMap[this.language] || ["En", "EN", "en"];
      for (const suffix of suffixes) {
        const key = `${baseKey}${suffix}`;
        if (row[key]) return row[key];
      }
      for (const suffix of ["En", "EN", "en", "Tc", "TC", "tc", "Sc", "SC", "sc"]) {
        const key = `${baseKey}${suffix}`;
        if (row[key]) return row[key];
      }
      return "";
    },
    async reloadPageData() {
      this.isLoading = true;
      try {
        const response = await fetch(this.dataUrl);
        if (!response.ok) {
          throw new Error(`Fetch failed with status: ${response.status}`);
        }

        const { result } = await response.json();
        const resultList = Array.isArray(result) ? result : [];
        this.pageData = resultList.find(({ type }) => type === "0") || null;
        this.listData = resultList.filter(({ type }) => type !== "0");
      } catch (error) {
        console.error("Error fetching eight centres data:", error);
        this.pageData = null;
        this.listData = [];
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<template>
  <div
    class="eightCentres jobSearch breadcrumbs-absolute"
    @click="closeSelectList"
    style="overflow: inherit"
  >
    <Breadcrumbs class="magazine-bread"></Breadcrumbs>
    <Loading v-show="isLoading"></Loading>
    <div
      ref="centreList"
      class="opp-contain row"
      style="background-color: #fff"
    >
      <div
        class="container container-fluid"
        style="max-width: 1440px; width: 100%;"
        :key="pageData"
      >
        <div v-if="$data.pageData">
          <h2 class="header-title__h1 Bold fontAudit">
           {{ getLocalizedValue($data.pageData, "title") }}
          </h2>
          <h3 class="sub-heading">
           {{ getLocalizedValue($data.pageData, "subTitle") }}
          </h3>
        </div>
        <div class="content-container">
          <div v-if="$data.listData.length" class="button-container">
            <div
              class="centre-item__wrapper"
              v-for="(row, index) in $data.listData"
              :key="index"
            >
              <div class="centre-item__content">
                <img
                  :src="row[`imageEn`]"
                  :alt="getLocalizedValue(row, 'title')"
                />
                <h3 class="SemiBold button-title">
                  {{ getLocalizedValue(row, "title") }}
                </h3>
              </div>
              <router-link
                class="centre-item__button"
                :to="{ path: `/eightcentres/${row.id}`, query: { lang: language } }"
              >
                {{ $t("message.learnMore") }}
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.header-title__h1 {
  font-size: 60px;
  text-align: center;
  margin: 90px 0 30px 0;
  font-family: SemiBold;
  color: #25255f;
}
.sub-heading {
  margin: 1em 0.7em;
  text-align: center;
  font-size: 22px;
}
.button-title {
  font-size: 22px;
}
.button-container {
  padding: 30px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;
}
.content-container {
  margin-bottom: 60px;
}
.centre-item__wrapper {
  display: flex;
  flex-direction: column;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 0px 7px;
  border-radius: 10px;
  padding: 20px 20px 30px;
  justify-content: space-between;
  flex: 0 0 calc((100% - 60px) / 4);
}
.centre-item__content {
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;
  margin-bottom: 18px;
}
.centre-item__content img {
  width: 80%;
}

.centre-item__button {
  border-radius: 20px;
  padding: 12px 32px;
  text-align: center;
  margin: 0 auto;
  line-height: 1;
  font-weight: bold;
  position: relative;
  color: rgb(246, 105, 35) !important;
}

.centre-item__button:before {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: 20px;
  border: 2px solid currentColor;
  transition: transform 0.1s ease;
}

.centre-item__button:hover:before {
  transform: scale(1.1);
}

@media only screen and (max-width: 1200px) {
  .centre-item__wrapper {
    flex: 0 0 240px;
  }
}
@media only screen and (max-width: 600px) {
  .centre-item__wrapper {
    flex: 0 0 100%;
  }
  .centre-item__content img {
    width: 50%;
  }
}
</style>
